import React from 'react';
import FranchiseForm from 'forms/FranchiseForm';

export default (): JSX.Element => <FranchiseForm />;
